import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ParametrizacaoService } from '@modules/parametrizacao/services/parametrizacao.service';
import { ParametrizacaoObject } from '@modules/visitas/services/models';
import * as toastr from 'toastr'

@Component({
  selector: 'app-parametrizacao',
  templateUrl: './parametrizacao.component.html',
  styleUrls: ['./parametrizacao.component.css']
})
export class ParametrizacaoComponent implements OnInit {

  yearMonthStart = "";
  yearMonthEnd = "";
  openOrClose = "";

  isLoading = false;

  isSAC = true;

  constructor(private parametrizacaoService: ParametrizacaoService) { }

  ngOnInit() {

    this.getValuesMAPV();
  }

  saveMAPV(){
    console.log(this.yearMonthStart, "start");
    console.log(this.yearMonthEnd, "end");
    //console.log(this.openOrClose, "openOrClose");

    if(this.yearMonthStart == null){
      toastr.error('Campo "AnoMês Inicio" é obrigatório');
      return;
    }

    if(this.yearMonthEnd == null){
      toastr.error('Campo "AnoMês Fim" é obrigatório');
      return;
    }

    if(this.openOrClose == ""){
      toastr.error('Campo "MAPV Aberto" é obrigatório');
      return;
    }

    let filtro = {
      yearMonthStart: this.yearMonthStart,
      yearMonthEnd: this.yearMonthEnd,
      openOrClose: this.openOrClose,
    }

    const params: ParametrizacaoObject = {
      yearMonthStart: filtro.yearMonthStart,
      yearMonthEnd: filtro.yearMonthEnd,
      yearMonthStartStr: filtro.yearMonthStart,
      yearMonthEndStr: filtro.yearMonthEnd,
      openOrClose: filtro.openOrClose
    }

    console.log(params)
    // typeof(params.yearMounthEnd);

    this.parametrizacaoService.saveMAPV(filtro).subscribe(
        resp=> {
                toastr.success("MAPV salvo")
              },
        error => {
                toastr.error("Error ao salvar MAPV")
              }
    )

  }

  statusChange(event){
    //const newVal = event.target.value;
    this.openOrClose = this.openOrClose;
    console.log(this.yearMonthStart, "start");
    console.log(this.yearMonthEnd, "end");
    console.log(this.openOrClose, "openOrClose");

  }

  private actionsForSuccess(message){
    toastr.success(message);
  }

  private actionsForError(message){
      toastr.error(message);
  }

  getValuesMAPV(){

    const params: ParametrizacaoObject = {
      yearMonthStart: "",
      yearMonthEnd: "",
      yearMonthStartStr: "",
      yearMonthEndStr: "",
      openOrClose: ""
    }

    this.parametrizacaoService.getValuesMAPV()
    .subscribe(
      data => {
        const param: ParametrizacaoObject = data;

        this.yearMonthStart = param.yearMonthStartStr;
        this.yearMonthEnd = param.yearMonthEndStr;
        this.openOrClose = param.openOrClose;

      },
      error => {
        console.log(error)
      }
    )
  }

  public formName = new FormGroup({

    fieldName: new FormControl("ddlOpenOrClose") //where "test is field default value"

  });

}
